module.exports = __webpack_public_path__ + "static/media/search.a3cdf812.svg";